import { Locator } from '@/lib/test.locators';

export const productCardLocatorsMap = [
  {
    type: 'function',
    element: 'div',
    id: 'productCard',
    property: (id: string) => `product-card-${id}`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardNameButton',
    property: (id: string) => `product-card-${id}-name-button`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardNameValue',
    property: (id: string) => `product-card-${id}-name-value`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardDropdownTrigger',
    property: (id: string) => `product-card-${id}-dropdown-trigger`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardDropdownTriggerEdit',
    property: (id: string) => `product-card-${id}-dropdown-trigger-edit`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardDropdownTriggerUseAsNewTemplate',
    property: (id: string) => `product-card-${id}-dropdown-trigger-use-as-new-template`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardDropdownTriggerStatusChange',
    property: (id: string) => `product-card-${id}-dropdown-trigger-status-change`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardDropdownTriggerDelete',
    property: (id: string) => `product-card-${id}-dropdown-trigger-delete`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardDescription',
    property: (id: string) => `product-card-${id}-description`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardStatusText',
    property: (id: string) => `product-card-${id}-status-text`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardStatusValue',
    property: (id: string) => `product-card-${id}-status-value`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardVersionText',
    property: (id: string) => `product-card-${id}-version-text`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardVersionValue',
    property: (id: string) => `product-card-${id}-version-value`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'productCardUpdatedAt',
    property: (id: string) => `product-card-${id}-updated-at`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'productCardUseAsNewProductButton',
    property: (id: string) => `product-card-${id}-use-as-new-product-button`,
  },
] as const;

type ProductCardLocatorId = Locator<typeof productCardLocatorsMap>;
type ProductCardReturn = (id: string) => string;

export const productCardLocators: Record<ProductCardLocatorId, ProductCardReturn> = productCardLocatorsMap.reduce(
  (acc, { id, property }) => {
    acc[id] = property;
    return acc;
  },
  {} as Record<ProductCardLocatorId, ProductCardReturn>,
);
